import xs from 'xstream'
import {div, p, h4, h, label, input, option, VNode, h5, textarea} from "@cycle/dom"
import {pathOr, propOr, reduce} from 'ramda'
import * as R from "ramda"

import {AUTHORIZATION, API, PARTICIPATION_FEE, SITE_TITLE, DEMO_IDS, MEMBER_PHOTO_URL, INPUT_INFO} from '../constant'
import {CheckResult, InputCheck, MemberType, WorkForm} from '../interface'
import { fmt00, num2FmtStr } from '../utils'

export const inputValue = pathOr('',['target', 'value'])
export const input2Prop = propName => e => {return {[propName]: inputValue(e)}}
export const prop2Value = value => {return {value}}

export const pageViewTempl = (pageName, eventInfo$ = xs.never(), title = SITE_TITLE) => contentView$ =>
	xs.combine(contentView$)
		.map(([contentView]:[xs<any>]) => 
					div(`.card.main.mt-2.${pageName}`, {attrs: {role: "main"}}, [
            div(".card-header",[h5([title])]),
            div(".card-body", [
              contentView,
            ]),
					]) //,
		)

export const inputTempl = (propId, desc, attrs, lbLen = 2, inpLen = 4, desc2=null) => (props, errCheck = {}) => {
	const err = propOr({check: true}, propId)(errCheck)
	const msg = (!err.check && err.message) ? div(`.col-sm-offset-${lbLen}.col-sm-${12 - lbLen}`,[div(".err", [err.message])]) : null
	const _desc2 = desc2 ? div(".exDesc",[desc2]) : null
	return div(".form-group",[
		label(`.control-label.col-sm-${lbLen}`,{attrs: {for:propId}},[desc, _desc2]),
		div(`.col-sm-${inpLen}`,[
			input(`#${propId}.form-control`, {attrs, props}),
		]),
		msg
	])
}

export const confirmTempl = (propId, desc, lbLen = 2, inpLen = 4) => (val) =>
	div(".form-group",[
		label(`.control-label.col-sm-${lbLen}`,{attrs: {for:propId}},[desc]),
		div(`.col-sm-${inpLen}.value`,[
			val
		])
	])

export const createApiReq = (apiName, method = "POST", progress = false) => {
	if (!API[apiName]) {
		throw(`API ${apiName} NOT FOUND`)
	}
	return (data = {}) => {
		return {
			url: API[apiName],
			category: apiName,
			method,
			withCredentials: false,
      headers: {
        Authorization: AUTHORIZATION,
      },
			send: data,
			progress
		}
	}
}
const DEFAULT_REQ = {
	method: "POST",
	withCredentials: false,
  headers: {
    Authorization: AUTHORIZATION,
  },
	progress: false
}
export const createApiReqEx = apiName => {
	if (!API[apiName]) {
		throw(`API ${apiName} NOT FOUND`)
	}
	return (param) => {
		return Object.assign({
				url: API[apiName],
				category: apiName
			},
			DEFAULT_REQ,
			param
		);
	}
}

const commError = resp$ => resp$.replaceError(() => xs.of({body: {message:"通信エラー", status: -5}}))
export const createApiResp = apiName => http$ =>
	http$	
		.select(apiName)
		.map(commError)
		.flatten()
		.map(resp => resp.body)

export const apiOK = respBody => propOr(-1, "status", respBody) === 0
export const apiNG = respBody => propOr(-1, "status", respBody) !== 0

export const isParticipationFee = log => log.get('type') === PARTICIPATION_FEE

export const createInputCheck = (config:InputCheck) => input$ =>
	input$
		.map(input => {
      const { varName, message, re, require } = config 
      const value = R.propOr("", varName, input)
      let check = R.isEmpty(value) && !require
      if (!check) {
        check = typeof re === "function" ? re(input) : re.test(value as string)
      }
			// const value = input[config.varName]
			// const {varName, message, re} = config
      // let check = typeof re === "function" ? re(input) : re.test(value as string)
			// if (!value) {
			// 	check = config.require ? false : true
			// }
			return Object.assign({}, {varName, value, message, check});
		})

export const isDemoUser = R.flip(R.includes)(DEMO_IDS)

export const fmtMember = num2FmtStr("0000000")

export const getMemberPhotoUrl = (id) => {
	const fmtId = fmtMember(id)
	return `${MEMBER_PHOTO_URL}${fmtId}.jpg`
}
	
export const getMemberType = R.compose(R.propOr(0, "type"), R.last, R.sortBy(R.prop("type")))
export const getMemberId = (type: MemberType) => R.compose(R.propOr(0, "id"), R.find(R.propEq(type, "type")))
export const getMemberByType = (type: MemberType) => R.find(R.propEq(type, "type"))
export const getMemo = R.tryCatch(R.compose(JSON.parse, R.prop("memo")), R.always({}))

export const doValidation = (inputChecks: InputCheck[]) => (input: any) =>
  R.reduce(
    (acc: any, checkInfo: InputCheck) => {
      // console.log(checkInfo)
      const { varName, message, re, require, delegate } = checkInfo
      if (delegate) {
        return R.mergeRight(acc, delegate(input, checkInfo))
      }
      const value = R.propOr("", varName, input)
      let check = R.isEmpty(value) && !require
      if (!check) {
        check = typeof re === "function" ? re(input) : re.test(value as string)
      }
      // let check =
      //   typeof re === "function" ? re(input) : re.test(value as string)
      // if (check && !value) {
      //   check = require ? false : true
      // }
      return R.mergeRight(acc, { [varName]: { message, check, require } })
    },
    {},
    inputChecks,
  )
  export const createTextInput = (key: string, readOnly = false) => {
    const info = R.prop(key as any, INPUT_INFO)
    const name = R.prop("name", info)
    const size = R.propOr(3, "size", info)
    const maxLength = R.prop("maxLength", info)
    const minLength = R.prop("minLength", info)
    const placeholder = R.prop("placeholder", info)
    const inputmode = R.prop("inputmode", info)
  
    return (inputs: any, errorCheck?: CheckResult | undefined) => {
      const value = R.prop(key as any, inputs)
      const err = R.prop(key as any, errorCheck)
      let valid: string = ""
      let errMsg: VNode | null = null
      if (err) {
        valid = err.check ? (err.require ? ".is-valid" : "") : ".is-invalid"
        if (err.message) {
          errMsg = div(".invalid-feedback", [err.message])
        }
      }
      const desc = readOnly ? undefined : R.prop("desc", info)
      const inputClass = readOnly
        ? ".form-control-plaintext.readOnly.fw-bold"
        : `.form-control${valid}`
      const inputAttr = readOnly 
        ? {
          type: "text",
          name: key,
          readOnly: true,
        }
        : {
            type: "text",
            name: key,
            placeholder,
            minLength,
            maxLength,
            inputmode,
        }
      return div(`.col-md-${size}`, [
        label(".form-label", [name]),
        input(`${inputClass}`, {
          attrs: inputAttr,
          props: { value },
        }),
        desc ? div(".form-text", [desc]) : null,
        errMsg,
      ])
    }
  }
  export const createTextArea = (key: string, readOnly = false) => {
    const info = R.prop(key as any, INPUT_INFO)
    const name = R.prop("name", info)
    const size = R.propOr(3, "size", info)
    const placeholder = R.prop("placeholder", info)
  
    return (inputs: any, errorCheck: CheckResult) => {
      const value = R.prop(key as any, inputs)
      const err = R.prop(key as any, errorCheck)
      let valid: string = ""
      let errMsg: VNode | null = null
      if (err) {
        valid = err.check ? (err.require ? ".is-valid" : "") : ".is-invalid"
        if (err.message) {
          errMsg = div(".invalid-feedback", [err.message])
        }
      }
      const desc = readOnly ? undefined : R.prop("desc", info)
      const inputClass = readOnly
        ? ".form-control-plaintext.readOnly.fw-bold"
        : `.form-control${valid}`
      // const inputAttr = readOnly ? true : undefined
      return div(`.col-md-${size}`, [
        label(".form-label", [name]),
        textarea(`.${inputClass}`, {
          attrs: {
            name: key,
            placeholder,
            readOnly,
          },
          props: { value },
        }),
        desc ? div(".form-text", [desc]) : null,
        errMsg,
      ])
    }
  }

  export const createTextInput_ = (key: string) => {
    const info = R.prop(key as any, INPUT_INFO)
    const name = R.prop("name", info)
    const size = R.propOr(2, "size", info)
    const maxLength = R.prop("maxLength", info)
    const minLength = R.prop("minLength", info)
    const placeholder = R.prop("placeholder", info)
    const inputmode = R.prop("inputmode", info)
  
    return (inputs: any, errorCheck: CheckResult) => {
      const value = R.prop(key as any, inputs)
      const err = R.prop(key as any, errorCheck)
      let valid: string = ""
      let errMsg: VNode | null = null
      if (err) {
        console.log(err)
        valid = err.check ? (err.require ? ".is-valid" : "") : ".is-invalid"
        if (err.message) {
          errMsg = div(".invalid-feedback", [err.message])
          console.log(err?.message)
        }
      }
      const desc = R.prop("desc", info)
      return div(`.pure-u-1.pure-u-md-1-${size}`, [
        label(".form-label", [name]),
        input(`.pure-u-24-24.pure-u-md-23-24${valid}`, {
          attrs: {
            type: "text",
            name: key,
            placeholder,
            minLength,
            maxLength,
            inputmode,
          },
          props: { value },
        }),
        desc ? div(".form-text", [desc]) : null,
        errMsg,
      ])
    }
  }
  
  export const dateOptions = (from: number, to: number, nullable = false) => (selected?: string) => {
    const opts = R.map((m: number) =>
      option(
        {
          attrs: { value: fmt00(m) },
          props: { selected: selected === fmt00(m) },
        },
        [fmt00(m)],
      ),
    )(R.range(from, from + to))
    if (nullable) {
      opts.unshift(option({ attrs: { value: "" } }, [""]))
    }
    return opts
  }
  

const _drawDesc = (desc: string) => div(".form-text", [desc])
export const drawDesc = (desc: string | string[]) => {
  if (!desc) {
    return null
  }
  if (!Array.isArray(desc)) {
    return _drawDesc(desc)
  }
  return div(R.map(_drawDesc, desc))
}    

export const eventMapper = (key: string, value: string) => (e: any) => ({
  [R.prop(key, e)]: R.prop(value, e),
})

export const createCheckbox = (key: string, group: string) => {
  const info = R.prop(key as any, INPUT_INFO)
  const name = R.prop("name", info)
  const desc = R.prop("desc", info)
  return (userForm: WorkForm, errorCheck: CheckResult, disabled = false) => {
    const chkError = R.pathOr(true, [group, "check"], errorCheck)
    const checked = R.propOr(false, key, userForm)
    const valid = chkError ? "" : ".is-invalid"
    return div([
      input(`#${key}.form-check-input${valid}`, {
        attrs: { type: "checkbox", name: key, disabled },
        props: { checked },
      }),
      label(".form-check-label.ms-2", { attrs: { for: key } }, [name]),
      // desc ? div(".form-text", [desc]) : null,
      desc ? drawDesc(desc) : null,
    ])
  }
}
export const createCheckInfo = (
  varName: string,
  re: RegExp | Function,
  message: string,
  require = true,
  delegate = undefined,
) =>
  ({
    varName,
    re,
    message,
    require,
    delegate,
  } as InputCheck)
